/** The app mark, shared by the header, the public page and the auth screens. */
export function Logo({ large = false }: { large?: boolean }) {
  return (
    <span
      className={`grid shrink-0 place-items-center bg-accent/15 text-accent ${
        large ? 'size-10 rounded-xl' : 'size-7 rounded-md'
      }`}
    >
      <svg
        viewBox="0 0 16 16"
        className={large ? 'size-5' : 'size-4'}
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M2 3.5A1.5 1.5 0 0 1 3.5 2h9A1.5 1.5 0 0 1 14 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 12.5v-9Zm3 2a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5H5Zm0 3a.75.75 0 0 0 0 1.5h4a.75.75 0 0 0 0-1.5H5Z" />
      </svg>
    </span>
  );
}
